/**
 * Guarda o access token em memória do módulo — nunca em `localStorage`.
 *
 * Token em storage persistente é alvo de XSS: qualquer script injetado o lê e o
 * exfiltra. Em memória, ele morre com a aba, e a sessão é reconstruída pelo
 * cookie `httpOnly` do refresh, que o JavaScript não alcança.
 *
 * Fica fora do React porque as funções de query precisam dele sem estar dentro
 * de um componente.
 */

let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}
